import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  ...requestCases('GET_REFERRAL', { success: dataAs('get_referral_Data') }),
});
